/* goto with js */
;
(function () {

    var $btn = $('.js-m-goto');
    if (!$btn.length) return false;

    $btn.on('click', function () {
        var url = $(this).data('url');

        if (typeof url !== 'undefined') {
            var win;
            if (typeof $(this).data('blank') !== 'undefined') {
                win = window.open(url, '_blank');
                win.focus();
            } else {
                window.location.href = url
            }
        }

    });

})();